export default __webpack_public_path__ + "static/media/bookmarked-icon.a2e1d0c2.svg";